module.exports = __webpack_public_path__ + "static/media/12.fd3c1031.jpg";